// Helpers for the SVGs the /tikz/render endpoint returns (TeX-to-SVG output), inlined into the page.

// The converter names its glyphs and clip paths id="glyph-0-1", id="clip-0", ... in every SVG. Inlined in
// one page those ids collide, so each picture draws its text with the first picture's glyphs (MC
// options showed option A's "12" and "30" in every option). Give each SVG its own id prefix.
let svgCount = 0;
export function namespaceSvgIds(svg: string, prefix = `tikz${++svgCount}`): string {
  return svg
    .replace(/\bid="([^"]+)"/g, `id="${prefix}-$1"`)
    .replace(/\bhref="#([^"]+)"/g, `href="#${prefix}-$1"`)
    .replace(/url\(#([^)]+)\)/g, `url(#${prefix}-$1)`);
}

// The converter writes the picture size as unitless numbers that are really TeX points, so browsers
// draw 1pt as 1px and a 10pt TikZ label comes out at 10px, well below the 16px body text.
// Scale every rendered TikZ SVG so 10pt TeX text matches 16px body text, but never wider than
// its container (on a phone the picture shrinks to fit instead of overflowing).
export const TIKZ_PX_PER_PT = 1.6;

export function sizeTikzSvg(svg: SVGSVGElement): void {
  const width = parseFloat(svg.getAttribute('width') || '');
  if (!(width > 0) || !svg.getAttribute('viewBox')) return;
  svg.style.width = `${Number((width * TIKZ_PX_PER_PT).toFixed(1))}px`;
  svg.style.maxWidth = '100%';
  svg.style.height = 'auto';
}
